<script>
  import SpineUnitLeft from "./SVGSpineUnitLeft.svelte";
  import SpineUnitRight from "./SVGSpineUnitRight.svelte";
  import ScifiFrame from "./SVGscifiFrame.svelte";
  import LCorner from "./LCorner.svelte";

  import { fade, slide, scale } from "svelte/transition";

  let visible = false;

  function typewriter(node, { speed = 5 }) {
    const valid =
      node.childNodes.length === 1 &&
      node.childNodes[0].nodeType === Node.TEXT_NODE;

    if (!valid) {
      throw new Error(
        `This transition only works on elements with a single text node child`
      );
    }

    const text = node.textContent;
    const duration = text.length / (speed * 0.01);

    return {
      duration,
      tick: (t) => {
        const i = ~~(text.length * t);
        node.textContent = text.slice(0, i);
      },
    };
  }

  window.addEventListener("load", function () {
    // Get the container element
    var spinebtnContainer = document.getElementById("spine-controller");

    // Get all buttons with class="btn" inside the container
    var btnSpine = spinebtnContainer.getElementsByClassName("spine-unit");

    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btnSpine.length; i++) {
      btnSpine[i].addEventListener("mouseover", function () {
        var current = document.getElementsByClassName(" active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
      });
    }
  });
  /**
 *
 *
var slideIndex = 0;



export function showSlides() {
  var i;
  //console.log('area element id = ' + id);

  var imageNumber = this.getAttribute("data-image-number");
  //alert("The " + ele.innerHTML + " is a " + imageNumber + ".");
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("dot");
  slides[imageNumber - 1].style.display = "none";

  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }

  slides[imageNumber - 1].style.display = "block";


}
 */
  const projects = [
    {
      no: "1",
      id: "beauty",
      name: "The Pursuit of Beauty",
      image: " /images/Beauty.png",
      link: "https://bea-nu.vercel.app/",
      description: "Interactive Love letter",
    },
       {
      no: "1",
      id: "words",
      name: "Words without a home",
      image: " /images/wordswithouthome.png",
      link: "https://wordswithouthome.vercel.app/",
      description: "A sanctuary for the unsaid.",
    },
    {
      no: "1",
      id: "stealth",
      name: "Stealth Game Concept",
      image: " /images/STEALTH.png",
      link: "https://www.behance.net/gallery/112545991/Pyke-Stealth-game",
      description: "UI concept for a Stealth Game",
    },
    {
      no: "2",
      id: "dark-future",
      name: "Dark Future",
      image: "images/DARK FUTURE.png",
      link: "https://www.behance.net/gallery/71387117/Dark-Future",
      description: "3D art of a dystopian city",
    },
    {
      no: "3",
      id: "lynn",
      name: "Lynn",
      image: "images/LYNN.png",
      link: "https://glossy-ink-3c8.notion.site/Lynn-bdf9791f49c0418abdeef9f0f7fa8ecc?pvs=4",
      description: "2.5D platformer done in Unreal Engine",
    },
    {
      no: "4",
      id: "icarus",
      name: "ICARUS",
      image: "/images/ICARUS.png",
      link: "https://www.behance.net/gallery/99721631/STEAMPUNK-HUD-DESIGNS",
      description: "UI concept based on Steampunk theme",
    },
    {
      no: "5",
      id: "division",
      name: "Division (Redesign)",
      image: "images/THE DIVISION.png",
      link: "https://www.behance.net/gallery/108280961/DIVISION-III-Fan-art",
      description: "UI concept redesign of The Division",
    },
    {
      no: "6",
      id: "drifter",
      name: "Drifter",
      image: "/images/DRIFTER.png",
      link: "https://www.youtube.com/watch?v=yK0yUYrHmXQ",
      description: "3D art done in Unreal Engine 4",
    },
    {
      no: "7",
      id: "blackmonarch",
      name: "Black Monarch ",
      image: "/images/Black Monarch.png",
      link: "https://www.behance.net/gallery/108694895/The-Black-Monarch",
      description: "Graphic Design concept exploration",
    },
  ];

  let selectedProject = 0;
</script>

<section class="section-03" id="works">
  <div class="frame-container"><ScifiFrame /></div>
  <div class="text-container" />
  <div class="slideshow-container">
    <div class="mySlides ">
      <img
        transition:slide
        src={projects[selectedProject].image}
        alt={projects[selectedProject].name}
        style="width:100%"
      />
      <div class="text-box">
        <div class="pw-name">{projects[selectedProject].name}</div>
        <div class="line" />
        <div class="pw-description">
          {projects[selectedProject].description}
        </div>
        <a href={projects[selectedProject].link} target="_blank"> See more</a>
      </div>
    </div>
  </div>
  <div class="spine-container" id="spine-controller">
    <ul class="spine-controller-ul dot-nav">
      {#each projects as project, index}
        <li
          class="spine-unit dot"
          on:mouseover={() => (selectedProject = index)}
          on:focus={() => (selectedProject = index)}
        />
      {/each}
    </ul>
  </div>

  <div class="title" >
    <svg
      width="100%"
      height="16"
      viewBox="0 0 463 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_121_3913" fill="white">
        <path d="M40 8.5L0 8.5L8.75085e-08 7.5L40 7.5L40 8.5Z" />
      </mask>
      <path
        d="M40 8.5L40 9.5L41 9.5L41 8.5L40 8.5ZM0 8.5L-1 8.5L-1 9.5L-8.75085e-08 9.5L0 8.5ZM8.75085e-08 7.5L1.75017e-07 6.5L-1 6.5L-1 7.5L8.75085e-08 7.5ZM40 7.5L41 7.5L41 6.5L40 6.5L40 7.5ZM40 7.5L8.75085e-08 7.5L-8.75085e-08 9.5L40 9.5L40 7.5ZM1 8.5L1 7.5L-1 7.5L-1 8.5L1 8.5ZM0 8.5L40 8.5L40 6.5L1.75017e-07 6.5L0 8.5ZM39 7.5L39 8.5L41 8.5L41 7.5L39 7.5Z"
        fill="url(#paint0_linear_121_3913)"
        mask="url(#path-1-inside-1_121_3913)"
      />
      <path
        d="M149.198 13V3.54545H152.929C153.646 3.54545 154.257 3.68241 154.761 3.95632C155.266 4.22715 155.651 4.60417 155.915 5.08736C156.183 5.56747 156.317 6.12145 156.317 6.74929C156.317 7.37713 156.182 7.93111 155.911 8.41122C155.64 8.89133 155.248 9.26527 154.734 9.53303C154.223 9.80078 153.604 9.93466 152.878 9.93466H150.5V8.33274H152.555C152.939 8.33274 153.256 8.26657 153.506 8.13423C153.758 7.99882 153.946 7.81262 154.069 7.57564C154.195 7.33558 154.258 7.06013 154.258 6.74929C154.258 6.43537 154.195 6.16146 154.069 5.92756C153.946 5.69058 153.758 5.50746 153.506 5.3782C153.253 5.24586 152.933 5.17969 152.545 5.17969H151.197V13H149.198ZM160.995 13V3.54545H167.366V5.19354H162.994V7.44638H167.038V9.09446H162.994V11.3519H167.385V13H160.995ZM172.335 13V3.54545H176.065C176.779 3.54545 177.389 3.67318 177.894 3.92862C178.401 4.18099 178.788 4.53954 179.052 5.00426C179.32 5.46591 179.454 6.00911 179.454 6.63388C179.454 7.26172 179.319 7.80185 179.048 8.25426C178.777 8.7036 178.384 9.0483 177.871 9.28835C177.36 9.52841 176.741 9.64844 176.015 9.64844H173.517V8.0419H175.692C176.073 8.0419 176.39 7.98958 176.643 7.88494C176.895 7.7803 177.083 7.62334 177.206 7.41406C177.332 7.20478 177.395 6.94472 177.395 6.63388C177.395 6.31996 177.332 6.05528 177.206 5.83984C177.083 5.62441 176.893 5.46129 176.638 5.3505C176.386 5.23662 176.067 5.17969 175.682 5.17969H174.334V13H172.335ZM177.441 8.69744L179.791 13H177.584L175.285 8.69744H177.441ZM189.376 6.26456C189.339 5.89216 189.18 5.60286 188.9 5.39666C188.62 5.19046 188.24 5.08736 187.76 5.08736C187.434 5.08736 187.158 5.13352 186.933 5.22585C186.709 5.3151 186.536 5.43975 186.416 5.59979C186.299 5.75982 186.241 5.94141 186.241 6.14453C186.235 6.3138 186.27 6.46153 186.347 6.58771C186.427 6.7139 186.536 6.82315 186.675 6.91548C186.813 7.00473 186.973 7.08321 187.155 7.15092C187.337 7.21555 187.53 7.27095 187.737 7.31712L188.586 7.52024C188.999 7.61257 189.377 7.73568 189.722 7.88956C190.066 8.04344 190.365 8.23272 190.617 8.45739C190.87 8.68205 191.065 8.94673 191.204 9.25142C191.345 9.55611 191.418 9.90542 191.421 10.2994C191.418 10.878 191.27 11.3796 190.977 11.8043C190.688 12.226 190.27 12.5537 189.722 12.7876C189.177 13.0185 188.52 13.1339 187.751 13.1339C186.987 13.1339 186.322 13.0169 185.756 12.783C185.193 12.5491 184.753 12.2029 184.436 11.7443C184.122 11.2827 183.957 10.7118 183.942 10.0316H185.876C185.898 10.3486 185.989 10.6133 186.149 10.8256C186.312 11.0349 186.529 11.1934 186.8 11.3011C187.073 11.4058 187.383 11.4581 187.727 11.4581C188.066 11.4581 188.36 11.4089 188.609 11.3104C188.862 11.2119 189.057 11.0749 189.195 10.8995C189.334 10.7241 189.403 10.5225 189.403 10.2947C189.403 10.0824 189.34 9.90388 189.214 9.75923C189.091 9.61458 188.909 9.49148 188.669 9.38991C188.432 9.28835 188.141 9.19602 187.797 9.11293L186.767 8.8544C185.97 8.66051 185.341 8.35736 184.879 7.94496C184.417 7.53255 184.188 6.97704 184.191 6.27841C184.188 5.70597 184.34 5.20585 184.648 4.77805C184.959 4.35026 185.385 4.01634 185.927 3.77628C186.469 3.53622 187.084 3.41619 187.774 3.41619C188.475 3.41619 189.088 3.53622 189.611 3.77628C190.137 4.01634 190.547 4.35026 190.839 4.77805C191.131 5.20585 191.282 5.70135 191.291 6.26456H189.376ZM204.833 8.27273C204.833 9.30374 204.638 10.1809 204.247 10.9041C203.859 11.6274 203.33 12.1798 202.659 12.5614C201.991 12.94 201.24 13.1293 200.406 13.1293C199.566 13.1293 198.812 12.9384 198.144 12.5568C197.476 12.1752 196.948 11.6228 196.561 10.8995C196.173 10.1763 195.979 9.30066 195.979 8.27273C195.979 7.24171 196.173 6.36458 196.561 5.64134C196.948 4.91809 197.476 4.36719 198.144 3.98864C198.812 3.60701 199.566 3.41619 200.406 3.41619C201.24 3.41619 201.991 3.60701 202.659 3.98864C203.33 4.36719 203.859 4.91809 204.247 5.64134C204.638 6.36458 204.833 7.24171 204.833 8.27273ZM202.807 8.27273C202.807 7.60488 202.707 7.04167 202.507 6.5831C202.31 6.12453 202.031 5.77675 201.671 5.53977C201.311 5.30279 200.889 5.1843 200.406 5.1843C199.923 5.1843 199.501 5.30279 199.141 5.53977C198.781 5.77675 198.501 6.12453 198.301 6.5831C198.104 7.04167 198.006 7.60488 198.006 8.27273C198.006 8.94058 198.104 9.50379 198.301 9.96236C198.501 10.4209 198.781 10.7687 199.141 11.0057C199.501 11.2427 199.923 11.3612 200.406 11.3612C200.889 11.3612 201.311 11.2427 201.671 11.0057C202.031 10.7687 202.31 10.4209 202.507 9.96236C202.707 9.50379 202.807 8.94058 202.807 8.27273ZM217.602 3.54545V13H215.876L211.762 7.04936H211.693V13H209.694V3.54545H211.448L215.529 9.49148H215.612V3.54545H217.602ZM224.263 13H222.121L225.385 3.54545H227.961L231.22 13H229.078L226.71 5.70597H226.636L224.263 13ZM224.129 9.28374H229.189V10.8441H224.129V9.28374ZM235.738 13V3.54545H237.737V11.3519H241.791V13H235.738ZM255.011 13L252.306 3.54545H254.49L256.055 10.1147H256.133L257.86 3.54545H259.729L261.451 10.1286H261.534L263.099 3.54545H265.283L262.578 13H260.63L258.829 6.81854H258.755L256.959 13H255.011ZM277.888 8.27273C277.888 9.30374 277.692 10.1809 277.302 10.9041C276.914 11.6274 276.384 12.1798 275.713 12.5614C275.046 12.94 274.295 13.1293 273.461 13.1293C272.62 13.1293 271.866 12.9384 271.199 12.5568C270.531 12.1752 270.003 11.6228 269.615 10.8995C269.227 10.1763 269.033 9.30066 269.033 8.27273C269.033 7.24171 269.227 6.36458 269.615 5.64134C270.003 4.91809 270.531 4.36719 271.199 3.98864C271.866 3.60701 272.62 3.41619 273.461 3.41619C274.295 3.41619 275.046 3.60701 275.713 3.98864C276.384 4.36719 276.914 4.91809 277.302 5.64134C277.692 6.36458 277.888 7.24171 277.888 8.27273ZM275.861 8.27273C275.861 7.60488 275.761 7.04167 275.561 6.5831C275.364 6.12453 275.086 5.77675 274.726 5.53977C274.365 5.30279 273.944 5.1843 273.461 5.1843C272.977 5.1843 272.556 5.30279 272.196 5.53977C271.836 5.77675 271.556 6.12453 271.355 6.5831C271.159 7.04167 271.06 7.60488 271.06 8.27273C271.06 8.94058 271.159 9.50379 271.355 9.96236C271.556 10.4209 271.836 10.7687 272.196 11.0057C272.556 11.2427 272.977 11.3612 273.461 11.3612C273.944 11.3612 274.365 11.2427 274.726 11.0057C275.086 10.7687 275.364 10.4209 275.561 9.96236C275.761 9.50379 275.861 8.94058 275.861 8.27273ZM282.749 13V3.54545H286.479C287.193 3.54545 287.802 3.67318 288.307 3.92862C288.815 4.18099 289.201 4.53954 289.466 5.00426C289.733 5.46591 289.867 6.00911 289.867 6.63388C289.867 7.26172 289.732 7.80185 289.461 8.25426C289.19 8.7036 288.798 9.0483 288.284 9.28835C287.773 9.52841 287.154 9.64844 286.428 9.64844H283.93V8.0419H286.105C286.486 8.0419 286.803 7.98958 287.056 7.88494C287.308 7.7803 287.496 7.62334 287.619 7.41406C287.745 7.20478 287.808 6.94472 287.808 6.63388C287.808 6.31996 287.745 6.05528 287.619 5.83984C287.496 5.62441 287.307 5.46129 287.051 5.3505C286.799 5.23662 286.48 5.17969 286.095 5.17969H284.747V13H282.749ZM287.854 8.69744L290.204 13H287.997L285.698 8.69744H287.854ZM294.66 13V3.54545H296.659V7.71413H296.783L300.186 3.54545H302.582L299.073 7.77876L302.623 13H300.232L297.642 9.11293L296.659 10.3132V13H294.66ZM312.055 6.26456C312.018 5.89216 311.86 5.60286 311.58 5.39666C311.3 5.19046 310.92 5.08736 310.44 5.08736C310.113 5.08736 309.838 5.13352 309.613 5.22585C309.389 5.3151 309.216 5.43975 309.096 5.59979C308.979 5.75982 308.921 5.94141 308.921 6.14453C308.915 6.3138 308.95 6.46153 309.027 6.58771C309.107 6.7139 309.216 6.82315 309.355 6.91548C309.493 7.00473 309.653 7.08321 309.835 7.15092C310.016 7.21555 310.21 7.27095 310.417 7.31712L311.266 7.52024C311.678 7.61257 312.057 7.73568 312.402 7.88956C312.746 8.04344 313.045 8.23272 313.297 8.45739C313.55 8.68205 313.745 8.94673 313.884 9.25142C314.025 9.55611 314.097 9.90542 314.101 10.2994C314.097 10.878 313.95 11.3796 313.657 11.8043C313.368 12.226 312.949 12.5537 312.402 12.7876C311.857 13.0185 311.2 13.1339 310.43 13.1339C309.667 13.1339 309.002 13.0169 308.436 12.783C307.873 12.5491 307.433 12.2029 307.116 11.7443C306.802 11.2827 306.637 10.7118 306.622 10.0316H308.556C308.578 10.3486 308.668 10.6133 308.828 10.8256C308.992 11.0349 309.209 11.1934 309.479 11.3011C309.753 11.4058 310.063 11.4581 310.407 11.4581C310.746 11.4581 311.04 11.4089 311.289 11.3104C311.541 11.2119 311.737 11.0749 311.875 10.8995C312.014 10.7241 312.083 10.5225 312.083 10.2947C312.083 10.0824 312.02 9.90388 311.894 9.75923C311.771 9.61458 311.589 9.49148 311.349 9.38991C311.112 9.28835 310.821 9.19602 310.477 9.11293L309.447 8.8544C308.65 8.66051 308.021 8.35736 307.559 7.94496C307.097 7.53255 306.868 6.97704 306.871 6.27841C306.868 5.70597 307.02 5.20585 307.328 4.77805C307.639 4.35026 308.065 4.01634 308.607 3.77628C309.149 3.53622 309.764 3.41619 310.453 3.41619C311.155 3.41619 311.768 3.53622 312.291 3.77628C312.817 4.01634 313.226 4.35026 313.519 4.77805C313.811 5.20585 313.962 5.70135 313.971 6.26456H312.055Z"
        fill="white"
      />
      <mask id="path-4-inside-2_121_3913" fill="white">
        <path d="M423 7.5H463V8.5H423V7.5Z" />
      </mask>
      <path
        d="M423 7.5V6.5H422V7.5H423ZM463 7.5H464V6.5H463V7.5ZM463 8.5V9.5H464V8.5H463ZM423 8.5H422V9.5H423V8.5ZM423 8.5H463V6.5H423V8.5ZM462 7.5V8.5H464V7.5H462ZM463 7.5H423V9.5H463V7.5ZM424 8.5V7.5H422V8.5H424Z"
        fill="url(#paint1_linear_121_3913)"
        mask="url(#path-4-inside-2_121_3913)"
      />
    </svg>
  </div>
  <div class="corners">
    <LCorner />
    <div class="mirror"><LCorner /></div>
  </div>
</section>

<style>
  .title {
    top: 0px;
  }
  .line {
    height: 1px;
    background-color: white;
    width: 100%;
    margin: 10px;
  }

  a {
    transition: all 0.1s;
    color: #ff635c;
    font-weight: 400;
  }
  a:hover {
    color: rgb(235, 87, 87);
  }
  .text-box {
    border: 1px white solid;
    color: white;
    padding: 20px;
    min-width: 400px;
    width: auto;
    text-align: center;
    bottom: 0px;
    margin: auto;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    min-height: 100px;
    z-index: 10;
    background-color: rgba(1, 1, 1, 0.7);
  }
  .pw-name {
    font-size: 24px;
  }

  .pw-description {
    font-size: 16px;
    font-weight: 100;
  }

  .frame-container {
    height: 100%;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 95px;
    bottom: 0px;
    opacity: 0.6;
  }

  .corners {
    display: flex;
    width: 100%;
    justify-content: space-between;
    bottom: 0px;
    position: absolute;
    padding: 0px 100px;
    opacity: 0.2;
    transition: all 3s;
  }
  .corners:hover {
    opacity: 1;
  }
  .mirror {
    transform: scaleX(-1);
  }
  .spine-unit {
    transition: all 0.1s;
  }
  .section-03:hover .frame-container {
    display: block;
  }
  .section-03 .frame-container {
    display: none;
  }

  .spine-unit {
    border-radius: 16px;
    margin: 8px;
    border: 1px solid white;
    background: #f0232300;
    cursor: pointer;
    text-align: center;
    height: 16px;
    width: 16px;
    margin: 2px;
    transform: scale(0.5);
  }

  .spine-container:hover .spine-controller-ul {
    bottom: 0px;
    margin: auto;
  }

  .spine-unit:hover {
    box-shadow: inset 0px -10px 10px rgba(182, 55, 55, 0.205),
      inset 0px 4px 10px 5px rgb(235, 33, 7);
    transform: scale(0.6);
    color: rgba(1, 1, 1, 0);
  }

  .spine-container:hover .spine-controller-ul li {
    margin: 10px;
    height: 16px;
    width: 16px;
    transform: scale(1);
  }
  .frame-container:hover {
    opacity: 0.1;
  }
  .text {
    z-index: 11;
    text-transform: capitalize;
  }

  .text a {
    background: rgba(1, 1, 1, 0.5);
    width: fit-content;
    margin: auto;
    padding: 10px;
    border: 1px solid white;
  }
  .text:hover a {
    font-weight: 600;
    background: white;
    color: black;
  }

  @media only screen and (max-width: 800px) {
    .text-box {
      min-width: 320px;
    }
    #spine-controller {
      transform: scale(1) translate(0px, -300px);
    }
    #spine-controller:hover {
      transform: scale(1) translate(0px, -300px);
    }

    .spine-container:hover .spine-controller-ul li {
      transform: scale(1);
      margin-top: 75px;
    }
    .text {
      font-size: 24px;
      position: absolute;
      vertical-align: middle;
      left: 0px;
      right: 0px;
      text-align: center;
      display: inline-grid;
      align-items: baseline;
      height: auto;
      align-content: space-evenly;
    }
    .mySlides img {
      padding: 20px;
      height: 100%;
      margin-bottom: 40px;
    }
    .text a {
      background: rgba(1, 1, 1, 0.5);
      width: fit-content;
      margin: auto;
      padding: 10px;
      border: 1px solid white;
      font-weight: 200;
    }
  }
</style>
